'use client';

import { Badge } from '../Badge';

interface BalanceProps {
  tier: string;
  count: number;
}

export const Balance: React.FC<BalanceProps> = ({
  tier,
  count,
}: BalanceProps) => {
  if (count <= 1) {
    return null;
  }
  return (
    <Badge
      tier={tier}
      count={<>x{count}</>}
    />
  );
};
